import { render, staticRenderFns } from "./project-saved-search.vue?vue&type=template&id=591a6c92&"
import script from "./project-saved-search.vue?vue&type=script&lang=js&"
export * from "./project-saved-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports